module.exports = __webpack_public_path__ + "img/moon-medium.34cadabd.png";